/* ==========================================================================
   Mila — AI asistentkinja widget (imed.rs)

   Poziva IZOLOVAN endpoint na Coworker Apoteka Next.js app-u (Hetzner server,
   isti gde rade apoteke.coworker.rs i command.coworker.rs), preko CORS-a:
     POST https://apoteke.coworker.rs/api/imed/chat  -> chat
     GET  https://apoteke.coworker.rs/api/imed/chat  -> lagan health-check

   Nema build koraka/framework-a (čisti Shopify tema asset) — vanilla JS,
   samostalan fajl. Razgovor se čuva u sessionStorage (briše se sa tabom),
   NE u localStorage (namerno — svež razgovor pri sledećoj poseti).
   ========================================================================== */
(function () {
  "use strict";

  var ENDPOINT = "https://apoteke.coworker.rs/api/imed/chat";
  var STORAGE_KEY = "imedMilaMessages";
  var MAX_ISTORIJA_SLANJE = 20; // mora pratiti MAX_PORUKA na backendu
  var MAX_DUZINA_PORUKE = 500; // client-side (blaže od backend granice 2000, sprečava predugačke upite)
  var HEALTH_RECHECK_MS = 60000;

  var QUICK_REPLIES = [
    "Preporuka za suvu kožu",
    "Vitamini za decu",
    "Status dostave",
    "Kako da vratim proizvod?",
  ];

  var FALLBACK_TEKST =
    "Asistentkinja je trenutno nedostupna. Pišite nam na info@imed.rs.";

  var fab = document.getElementById("imedAssistantFab");
  var panel = document.getElementById("imedAssistantPanel");
  var closeBtn = document.getElementById("imedAssistantClose");
  var body = document.getElementById("imedAssistantBody");
  var form = document.getElementById("imedAssistantForm");
  var input = document.getElementById("imedAssistantInput");
  var sendBtn = document.getElementById("imedAssistantSend");
  var statusWrap = document.getElementById("imedAssistantStatus");
  var statusText = statusWrap ? statusWrap.querySelector(".imed-assistant-panel__status-text") : null;

  if (!fab || !panel || !form || !input || !body) return; // markup nije prisutan — ništa ne radi

  var messages = ucitajIstoriju();
  var poslednjaProveraZdravlja = 0;
  var jePrviPut = messages.length === 0;
  var zauzeto = false; // sprečava dupli submit dok čekamo odgovor

  // ---------------------------------------------------------------------
  // Perzistencija (sessionStorage)
  // ---------------------------------------------------------------------
  function ucitajIstoriju() {
    try {
      var sirovo = window.sessionStorage.getItem(STORAGE_KEY);
      if (!sirovo) return [];
      var niz = JSON.parse(sirovo);
      if (!Array.isArray(niz)) return [];
      return niz.filter(function (p) {
        return p && (p.role === "user" || p.role === "assistant") && typeof p.content === "string";
      });
    } catch (e) {
      return [];
    }
  }

  function sacuvajIstoriju() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
    } catch (e) {
      /* privatni režim / puna kvota — razgovor jednostavno neće preživeti reload, nije kritično */
    }
  }

  // ---------------------------------------------------------------------
  // Bezbedno renderovanje teksta (escape + linkifikacija SAMO imed.rs URL-ova)
  // ---------------------------------------------------------------------
  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function linkifyImedUrls(escapedHtml) {
    // Ulaz je VEĆ escape-ovan (nema živog HTML-a) — bezbedno je ubaciti <a> oko
    // tačno prepoznatih https://imed.rs/... URL-ova bez rizika od injekcije.
    return escapedHtml.replace(
      /https:\/\/imed\.rs\/[^\s<>"']*/g,
      function (url) {
        // Ukloni eventualnu zaostalu interpunkciju na kraju (npr. tačka na kraju rečenice).
        var trailing = "";
        var match = url.match(/[.,;:!?)]+$/);
        if (match) {
          trailing = match[0];
          url = url.slice(0, -trailing.length);
        }
        return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>" + trailing;
      }
    );
  }

  // ---------------------------------------------------------------------
  // Render poruka
  // ---------------------------------------------------------------------
  function dodajPuzuriUDom(uloga, tekst, opcije) {
    opcije = opcije || {};
    var div = document.createElement("div");
    var klasa = "imed-assistant-msg ";
    if (uloga === "user") klasa += "imed-assistant-msg--user";
    else if (opcije.fallback) klasa += "imed-assistant-msg--fallback";
    else klasa += "imed-assistant-msg--assistant";
    div.className = klasa;

    var bezbedno = escapeHtml(tekst);
    if (uloga === "assistant") bezbedno = linkifyImedUrls(bezbedno);
    div.innerHTML = bezbedno;

    body.appendChild(div);
    skrolujDole();
  }

  function skrolujDole() {
    body.scrollTop = body.scrollHeight;
  }

  var typingEl = null;
  function prikaziKucanje() {
    if (typingEl) return;
    typingEl = document.createElement("div");
    typingEl.className = "imed-assistant-typing";
    typingEl.setAttribute("aria-label", "Mila kuca");
    typingEl.innerHTML = "<span></span><span></span><span></span>";
    body.appendChild(typingEl);
    skrolujDole();
  }
  function skloniKucanje() {
    if (typingEl && typingEl.parentNode) typingEl.parentNode.removeChild(typingEl);
    typingEl = null;
  }

  function renderUvod() {
    var uvod = document.createElement("div");
    uvod.className = "imed-assistant-intro";
    uvod.textContent =
      "Ćao! Ja sam Mila, tu sam da pomognem oko izbora proizvoda, dostave i povrata. Kako mogu da pomognem?";
    body.appendChild(uvod);

    var chipsWrap = document.createElement("div");
    chipsWrap.className = "imed-assistant-quickreplies";
    QUICK_REPLIES.forEach(function (tekst) {
      var chip = document.createElement("button");
      chip.type = "button";
      chip.className = "imed-assistant-chip";
      chip.textContent = tekst;
      chip.addEventListener("click", function () {
        posaljiPoruku(tekst);
      });
      chipsWrap.appendChild(chip);
    });
    body.appendChild(chipsWrap);
  }

  function iscrtajCelokupnuIstoriju() {
    body.innerHTML = "";
    if (messages.length === 0) {
      renderUvod();
      return;
    }
    messages.forEach(function (p) {
      dodajPuzuriUDom(p.role, p.content, { fallback: p.fallback });
    });
  }

  // ---------------------------------------------------------------------
  // Health check (samo za "online" tačkicu — GET, bez Anthropic poziva)
  // ---------------------------------------------------------------------
  function proveriZdravljeAkoTreba() {
    var sada = Date.now();
    if (sada - poslednjaProveraZdravlja < HEALTH_RECHECK_MS) return;
    poslednjaProveraZdravlja = sada;

    postaviStatus("Povezivanje…", null);

    var kontroler = typeof AbortController !== "undefined" ? new AbortController() : null;
    var tajmer = kontroler
      ? setTimeout(function () {
          kontroler.abort();
        }, 4000)
      : null;

    fetch(ENDPOINT, { method: "GET", signal: kontroler ? kontroler.signal : undefined })
      .then(function (res) {
        if (tajmer) clearTimeout(tajmer);
        if (res.ok) postaviStatus("online", true);
        else postaviStatus("trenutno nedostupna", false);
      })
      .catch(function () {
        if (tajmer) clearTimeout(tajmer);
        postaviStatus("trenutno nedostupna", false);
      });
  }

  function postaviStatus(tekst, dostupno) {
    if (!statusWrap || !statusText) return;
    statusText.textContent = tekst;
    if (dostupno === null) {
      statusWrap.classList.remove("is-offline");
    } else if (dostupno) {
      statusWrap.classList.remove("is-offline");
    } else {
      statusWrap.classList.add("is-offline");
    }
  }

  // ---------------------------------------------------------------------
  // Slanje poruke
  // ---------------------------------------------------------------------
  function posaljiPoruku(tekstSirov) {
    var tekst = (tekstSirov || "").trim();
    if (!tekst || zauzeto) return;
    if (tekst.length > MAX_DUZINA_PORUKE) {
      tekst = tekst.slice(0, MAX_DUZINA_PORUKE);
    }

    // Ako je ovo prva poruka, ukloni uvod/quick-reply chipove iz DOM-a (ali ne
    // i istoriju — oni nikad nisu bili u `messages`).
    if (jePrviPut) {
      body.innerHTML = "";
      jePrviPut = false;
    }

    var poruka = { role: "user", content: tekst };
    messages.push(poruka);
    sacuvajIstoriju();
    dodajPuzuriUDom("user", tekst);

    input.value = "";
    zauzeto = true;
    sendBtn.disabled = true;
    prikaziKucanje();

    var zaSlanje = messages.slice(-MAX_ISTORIJA_SLANJE).map(function (p) {
      return { role: p.role, content: p.content };
    });

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: zaSlanje }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { status: res.status, data: data };
        });
      })
      .then(function (rezultat) {
        skloniKucanje();
        var data = rezultat.data || {};
        var tekstOdgovora = typeof data.text === "string" && data.text ? data.text : FALLBACK_TEKST;
        var jeFallback = !!data.fallback || rezultat.status >= 400;
        prihvatiOdgovor(tekstOdgovora, jeFallback);
      })
      .catch(function () {
        // Mrežna greška / backend nedostupan — graciozan lokalni fallback, BEZ rušenja widgeta.
        skloniKucanje();
        prihvatiOdgovor(FALLBACK_TEKST, true);
      })
      .then(function () {
        zauzeto = false;
        sendBtn.disabled = false;
      });
  }

  function prihvatiOdgovor(tekst, jeFallback) {
    var poruka = { role: "assistant", content: tekst, fallback: jeFallback };
    messages.push(poruka);
    sacuvajIstoriju();
    dodajPuzuriUDom("assistant", tekst, { fallback: jeFallback });
  }

  // ---------------------------------------------------------------------
  // Otvaranje / zatvaranje panela
  // ---------------------------------------------------------------------
  function otvoriPanel() {
    panel.hidden = false;
    // Sledeći frame — da tranzicija (opacity/transform) stvarno odigra.
    requestAnimationFrame(function () {
      panel.classList.add("is-open");
    });
    fab.setAttribute("aria-expanded", "true");
    if (body.children.length === 0) iscrtajCelokupnuIstoriju();
    proveriZdravljeAkoTreba();
    setTimeout(function () {
      input.focus();
    }, 150);
  }

  function zatvoriPanel() {
    panel.classList.remove("is-open");
    fab.setAttribute("aria-expanded", "false");
    setTimeout(function () {
      panel.hidden = true;
    }, 200);
  }

  fab.addEventListener("click", function () {
    if (panel.hidden) otvoriPanel();
    else zatvoriPanel();
  });
  if (closeBtn) closeBtn.addEventListener("click", zatvoriPanel);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hidden) zatvoriPanel();
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    posaljiPoruku(input.value);
  });
})();
